import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { styled } from '@mui/material';

export const StyledBriefcaseIcon = styled(BriefcaseIcon)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#FFFFFFB2' : '#00172EB2',
  width: 24,
}));
